 <template>
  <div class="wrap">
    <PolygonSelectNewPassword v-if="selectPwToken" :token="selectPwToken" />
    <div v-else>
      <h1>{{ $t('login.forgotPassword') }}</h1>

      <p>{{ $t('login.resetInstruction') }}</p>
      <v-text-field v-model="mail" :label="$t('login.username')"></v-text-field>
      <button v-if="!resetSubmitted" class="button--secondary" :class="{ 'is-loading' : loading }" @click="sendResetPasswordMail" :disabled="!mail"><i></i>{{ $t('login.sendMailButton') }}</button>

      <v-alert :value="resetSubmitted" color="success" icon="check_circle" outline>
        {{ $t('login.resetMailSuccess') }}
      </v-alert>

      <v-alert :value="error" color="error" icon="check_circle" outline>
        {{ $t('login.resetMailFailure') }}
      </v-alert>
    </div>
  </div>
</template>

<script>
import rpcService from '@/core/services/rpc-service'
import _ from 'lodash'

export default {
  props: ['enteredName', 'selectPwToken'],
  mounted() {
    this.mail = this.enteredName
  },
  data: () => ({
    mail: null,
    loading: false,
    error: false,
    resetSubmitted: false
  }),
  methods: {
    sendResetPasswordMail() {
      this.loading = true
      rpcService.resetPassword(this.mail, _.get(this, '$store.getters.currentLanguage.isoCode')).done(() => {
        this.error = false
        this.resetSubmitted = true
      }).fail(() => {
        this.error = true
      }).always(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.wrap { width: 100%; }
</style>
